import { __rest } from "tslib";
import React, { useContext, lazy, Suspense } from 'react';
import classnames from 'classnames';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
var DesktopNotificationAnimator = lazy(function () {
    return retry(function () {
        return import(
        /* webpackChunkName: "notifs" */
        './_partials/DesktopNotificationAnimator');
    });
});
var MobileNotificationAnimator = lazy(function () {
    return retry(function () {
        return import(
        /* webpackChunkName: "notifs" */
        './_partials/MobileNotificationAnimator');
    });
});
import s from './Notifications.scss';
import retry from '../utils/webpack/chunkRetry';
var Notifications = function (_a) {
    var queue = _a.queue, wrapperClassName = _a.wrapperClassName, animatorClassName = _a.animatorClassName, props = __rest(_a, ["queue", "wrapperClassName", "animatorClassName"]);
    // react-spring leaks in ssr, so must avoid rendering it
    var mounted = useIsMounted();
    var isMobile = useContext(MobileContext);
    if (!mounted || queue.length === 0) {
        return null;
    }
    return (React.createElement("div", { className: classnames(s['root'], wrapperClassName) },
        React.createElement(Suspense, { fallback: null }, isMobile ? (React.createElement(MobileNotificationAnimator, { queue: queue, notificationProps: props, className: animatorClassName })) : (React.createElement(DesktopNotificationAnimator, { queue: queue, notificationProps: props, className: animatorClassName })))));
};
export default Notifications;
//# sourceMappingURL=Notifications.js.map